import { compatWrapper } from '@backstage/core-compat-api';
import { NotFoundErrorPage as NotFoundErrorPageRef } from '@backstage/frontend-plugin-api';
import { SwappableComponentBlueprint } from '@backstage/plugin-app-react';

import { NotFoundPage } from '@spotify/confidence-common-react';

export const NotFoundErrorPage = SwappableComponentBlueprint.make({
  name: 'core-not-found-error-page',
  params: define =>
    define({
      component: NotFoundErrorPageRef,
      loader: () => () => compatWrapper(<NotFoundPage />),
    }),
});
